<form [hidden]="!viewCondition" class="form" (ngSubmit)="onSubmit()">
  @for (child of children; track child) {
    <ng-template #children></ng-template>
  }
</form>
